/**
 * @flow
 */

import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Button as BaseButton } from 'semantic-ui-react';

const Button = styled(
    React.forwardRef(({ uppercased, ...props }, ref) => {
        const handleRef = React.useCallback(
            instance => {
                const domNode = instance ? ReactDOM.findDOMNode(instance) : null;
                if (typeof ref === 'function') {
                    ref(domNode);
                } else if (ref && typeof ref === 'object') {
                    ref.current = domNode;
                }
            },
            [ref],
        );
        return <BaseButton {...props} ref={handleRef} />;
    }),
)`

    &.button {
        &.primary {
            box-shadow: none;
            background-color: #2185d0;
            text-shadow: none;
            transition: background-color .3s, box-shadow .3s;
            &:hover {
                background-color: #1678c2;
                box-shadow: none;
            }
            &:active {
                background-color: #1a7fcc;
                box-shadow: none;
            }
            &:focus {
                background-color: #1e87d6;
                box-shadow: none;
            }
        }
        &.secondary {
            box-shadow: none;
            background-color: #1b1c1d;
            text-shadow: none;
            transition: background-color .3s, box-shadow .3s;
            &:hover {
                background-color: #27292a;
                box-shadow: none;
            }
            &:active {
                background-color: #2d2f30;
                box-shadow: none;
            }
            &:focus {
                background-color: #2d2f30;
                box-shadow: none;
            }
        }
        &.basic {
            box-shadow: 0 0 0 1px rgba(34,36,38,.15) inset;
            opacity: .75;
            transition: opacity .3s;
            &.inverted {
                box-shadow: 0 0 0 1px rgba(255,255,255,.5) inset !important;
                &:hover {
                    box-shadow: 0 0 0 1px rgba(255,255,255,.5) inset !important;
                }
            }
            &:hover {
                opacity: 1;
                box-shadow: 0 0 0 1px rgba(34,36,38,.15) inset;
            }
        }
        ${props => props.uppercased && 'text-transform: uppercase;'}
    }
`;

export default Button;
